import ConfigurationService from "../../echartConfiguration";

/**
 * Responsável por fazer a lógica de processamento das cores atuais dos gráficos
 */
const configurationService = new ConfigurationService();

export const typedefToChartType = {
  GERAIS: 'simpleChart',
  EVOLUTIVO: 'evolutiveChart',
}

const supportedTypeDef = Object.keys(typedefToChartType);

function applyFiltersInQuestionData(questionPlottedData) {
  const evolutiveOcurrencesIndexes = questionPlottedData
    .filter((r) => r.resultado_type_def === 'EVOLUTIVO')
    .map(v => questionPlottedData.indexOf(v))
    .slice(1);

  const filters = {
    removeUnsupportedTypes: (dadosPlotagem, index) => {
      return supportedTypeDef.includes(dadosPlotagem.resultado_type_def)
    },
    removeDuplicatedEvolutiveTypes: (dadosPlotagem, index) => {
      return !evolutiveOcurrencesIndexes.includes(index);
    }
  };

  return questionPlottedData
    .filter(filters.removeUnsupportedTypes)
    .filter(filters.removeDuplicatedEvolutiveTypes);
}

/**
 * 
 */
export async function prepareReportChartColors(reportData, activeQuestionId, currentColorConfig) {
  const chartColorsByQuestions = [];

  const {
    surveyId,
    questions,
  } = reportData;

  if (activeQuestionId && typeof activeQuestionId === 'number') {
    chartColorsByQuestions.push(...currentColorConfig);
  }
  
  const colorConfigPromises = [];

  // Percorremos o array de perguntas da pesquisa
  questions.forEach((questionObject) => {
    // Recuperamos o id da pergunta iterada e os dados de plotagem
    const { id: questionId, dados_plotagem_relatorio } = questionObject;
    // Só executamos alguma lógica se o id da pergunta for diferente do id da pergunta atualmente selecionada pelo usuário
    if (questionId !== activeQuestionId) {
      applyFiltersInQuestionData(dados_plotagem_relatorio).forEach(dadosPlotagem => {
        const {
          resultado_type_def: definicaoGrafico,
        } = dadosPlotagem;

        const colorConfigPromise = configurationService.fetchConfigData(
          surveyId,
          questionId,
          typedefToChartType[definicaoGrafico],
        );

        colorConfigPromises.push({
          promise: colorConfigPromise,
          questionId,
          type: typedefToChartType[definicaoGrafico],
        });

      });
    }
  });

  let resolvedConfigs;

  try {
    resolvedConfigs = await Promise.all(colorConfigPromises.map(v => v.promise));
  } catch {
    resolvedConfigs = [...colorConfigPromises];
  }

  const resolvedConfigMapped = resolvedConfigs.map((v, i) => {
    delete colorConfigPromises[i].promise;
    const colors = (v && v.data && v.data.chartsColors) || {};

    return {
      ...colorConfigPromises[i],
      colors,
    };
  });

  chartColorsByQuestions.push(...resolvedConfigMapped);

  return chartColorsByQuestions;
}